var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
function _objectWithoutProperties(obj, keys) {
  var target = {};
  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }
  return target;
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import APIcon from '../APIcon';
import { InnerInput } from '../APInput';
import { getBEMClasses } from '../../../helpers/cssClassesHelper';
import './APPasswordInput.css';
var baseClass = 'ap-password-input';
var PasswordInput = function (_React$Component) {
  _inherits(PasswordInput, _React$Component);
  function PasswordInput(props) {
    _classCallCheck(this, PasswordInput);
    var _this = _possibleConstructorReturn(this, (PasswordInput.__proto__ || Object.getPrototypeOf(PasswordInput)).call(this, props));
    _this.handleClick = function () {
      _this.setState({
        reveal: !_this.state.reveal
      });
    };
    _this.renderIcon = function (bemClasses) {
      return React.createElement('span', {
        onClick: _this.handleClick,
        className: bemClasses('icon', {
          active: _this.state.reveal
        })
      }, React.createElement(APIcon, {
        name: 'eye'
      }));
    };
    _this.state = {
      value: '',
      reveal: false
    };
    return _this;
  }
  _createClass(PasswordInput, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
        customClass = _props.customClass,
        passedProps = _objectWithoutProperties(_props, ['customClass']);
      var bemClasses = getBEMClasses(baseClass, customClass);
      var iconComponent = this.renderIcon(bemClasses);
      return React.createElement('div', {
        className: bemClasses()
      }, React.createElement(InnerInput, Object.assign({
        customClass: customClass
      }, passedProps, {
        type: this.state.reveal ? 'text' : 'password',
        iconComponent: iconComponent
      })));
    }
  }]);
  return PasswordInput;
}(React.Component);
var APPasswordInput = function APPasswordInput(props) {
  return React.createElement(Field, Object.assign({
    name: props.name,
    component: PasswordInput
  }, props));
};
APPasswordInput.propTypes = {
  customClass: PropTypes.string
};
export default APPasswordInput;